// extracted by mini-css-extract-plugin
export default {"wrapper":"enrollment_complete_wrapper__GrYk1","subject_text":"enrollment_complete_subject_text__EjTp4","subject_id":"enrollment_complete_subject_id__foSnq"};